import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class PopupView extends AbstractView {

    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;

        this._target.gotoAndStop(0);

        this.createButton(this._target.continueButton, this._handleButton.bind(this));
        if (this._target.cancelButton) {
            this.createButton(this._target.cancelButton, this._handleButton.bind(this));
            this._centerX = (this._target.continueButton.x + this._target.cancelButton.x) / 2;
        }
        this._buttons.forEach(button => button.xOrig = button.target.x);

        this._animating = false;

        this._addBackground();
    }

    _addBackground() {
        if (!this.bg) {
            this.bg = this._target.addChildAt(new createjs.Shape(), 0);
            const tl = this._target.parent.localToLocal(-800, -1000, this._target);
            const br = this._target.parent.localToLocal(800, 1000, this._target);
            this.bg.graphics.f("rgba(0,0,0,.01)").r(tl.x, tl.y, br.x - tl.x, br.y - tl.y);
            this.bg.addEventListener("click", () => { });
        }        
    }


    /**
     * 
     * @param {String} title 
     * @param {String} body 
     * @param {Array<Object>} buttonParams - Per button: {label:"myLabel", callback:myFunction}. First button is ok button, optional second button is cancel button.
     * @param {String} type - determines frame to show
     */
    setContent(title, body, buttonParams, type = PopupView.GENERIC, professorState = PopupView.PROFESSOR_IDLE) {
        this._target.gotoAndStop(type);
        if (!isNull(title)) this._target.titleTextfield.text = title;
        if (!isNull(body) && !isNull(this._target.bodyTextfield)) this._target.bodyTextfield.text = body;

        this._buttons.forEach((button, idx) => {
            button.target.visible = false;
            const params = buttonParams[idx];
            if (params) {
                button.target.visible = true;
                button.setLabel(params.label);
                button.callback = params.callback;
                button.target.x = button.xOrig;
            }
        });
        if (this._centerX != null && !this._buttons[1].target.visible) {
            this._buttons[0].target.x = this._centerX;
        }
        //this._target.professor.gotoAndStop(professorState);
    }

    open(instant = false) {
        if (this._state != State.OPENED) {
            this._target.addChildAt(this.bg, 0);
            this._animateTo(1, State.OPENED, instant);
        }
    }

    close(instant = false) {
        if (this._state != State.CLOSED) {
            this._animateTo(0, State.CLOSED, instant);
        }
    }

    _animateTo(alpha, stateAtEnd, instant) {
        const onComplete = () => {
            this._state = stateAtEnd;
        }
        if (instant) {
            this._target.alpha = alpha;
            onComplete();
        } else {
            createjs.Tween.get(this._target).to({ alpha: alpha }, 100, createjs.Ease.quadOut).call(onComplete);
        }
    }

    _handleButton(e) {
        this.close();
        this._invoke(e.target.callback);
    }

    _invoke(callback) {
        if (!isNull(callback)) {
            callback();
        }
    }
}

PopupView.GENERIC = "generic";
PopupView.END = "end";

const State = { CLOSED: 0, CLOSING: 1, OPENING: 2, OPENED: 3 };

PopupView.PROFESSOR_CORRECT_ANSWER = "profcorrect";
PopupView.PROFESSOR_INCORRECT_ANSWER = "profincorrect";
PopupView.PROFESSOR_IDLE = "profnatural";
